import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export const proctorResultApiKeyStore = {
    uploadProctorResultFiles: (): MutationKeyConfig => ({
        mutationKey: [`UPLOAD_PROCTOR_REUSLT_FILES`],
        route: `/ProctorResults`,
        action: 'POST',
    }),
    getProjectProctorResults: (projectID: number): QueryKeyConfig => ({
        queryKey: [`GET_PROJECT_PROCTOR_REUSLT`, projectID],
        route: `/ProctorResults?ProjectID=${projectID}`,
        isEnabled: !!projectID
    }),
    getUnitProctorResults: (unitID: number): QueryKeyConfig => ({
        queryKey: [`GET_UNIT_PROCTOR_REUSLT`, unitID],
        route: `/ProctorResults?UnitID=${unitID}`,
        isEnabled: !!unitID
    }),
    mapProctorResult: (): MutationKeyConfig => ({
        mutationKey: [`MAP_PROCTOR_RESULT`],
        route: `/ProctorResults/MapProctorResults`,
        action: 'POST',
    }),
    deleteProctorResult: (id: number): MutationKeyConfig => ({
        mutationKey: [`DELETE_PROCTOR_RESULT`, id],
        route: `/ProctorResults/${id}`,
        action: 'DELETE',
    }),
    updateProctorResultFiles: (): MutationKeyConfig => ({
        mutationKey: [`UPDATE_PROCTOR_RESULT_FILES`],
        route: `/ProctorResults`,
        action: 'PUT',
    }),
};
